<fieldset>
    <legend class="ams-legend-title">&nbsp;&nbsp;Award History&nbsp;&nbsp;</legend>
    <div class="row mt-3">
        <kendo-grid [data]="awardAuditGridData" [columnMenu]="{sort: true, filter: true, columnChooser: false}" [pageSize]="auditPageSize"
            [skip]="auditSkip" (pageChange)="auditPageChange($event)" [resizable]="true"
            (dataStateChange)="auditDataStateChange($event)" (filterChange)="auditFilterChange($event)" [pageable]="{
                    buttonCount: buttonCount,
                    info: info,
                    type: typedg,
                    pageSizes: pageSizes,
                    previousNext: previousNext
                }" filterable="menu" [filter]="awardFilter">
            <kendo-grid-column title="Module Name" field="ModuleName" [style]="{'cursor': 'pointer'}">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="moduleNameValue" textField="ModuleName" valueField="ModuleName"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="moduleNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.ModuleName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Action" field="Operation">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="operation" textField="Operation" valueField="Operation"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="operationNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.Operation}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Modified By" field="DisplayName">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="displayName" textField="DisplayName" valueField="DisplayName"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="displayNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.DisplayName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Modified Date" field="LastModifiedDate" filter="date" format="{0:dd MMM yyyy}">
                <ng-template kendoGridEditTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-textbox-container>
                        <kendo-datepicker [format]="'dd MMM yyyy'">
                        </kendo-datepicker>
                    </kendo-textbox-container>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.LastModifiedDate | date:'dd MMM yyyy'}}</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</fieldset>

<fieldset>
    <legend class="ams-legend-title">&nbsp;&nbsp;Document History&nbsp;&nbsp;</legend>
    <div class="row mt-3">
        <kendo-grid [data]="documentGridData" [columnMenu]="{sort: true, filter: true, columnChooser: false}"
            (pageChange)="documentPageChange($event)" (dataStateChange)="documentDataStateChange($event)"
            (filterChange)="documentFilterChange($event)" filterable="menu" [pageSize]="documentPageSize"
            [skip]="documentSkip" [pageable]="{
                    buttonCount: buttonCount,
                    info: info,
                    type: typedg,
                    pageSizes: pageSizes,
                    previousNext: previousNext
                }" filterable="menu" [filter]="documentFilter" [resizable]="true">
            <kendo-grid-column title="Module Name" field="moduleName" [style]="{'cursor': 'pointer'}">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="documentModuleName" textField="moduleName" valueField="moduleName"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="documentModuleNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.moduleName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Document Name" field="documentName">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="documentName" textField="documentName" valueField="documentName"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="documentNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.documentName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Document Type" field="documentTypeName">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="documentTypeName" textField="documentTypeName"
                        valueField="documentTypeName" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="documentTypeNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.documentTypeName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Description" field="description">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="description" textField="description" valueField="description"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="descriptionChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.description}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Action" field="operation">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="documentOperation" textField="operation" valueField="operation"
                        [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="documentOperationNameChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.operation}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Modified By" field="modifiedByUser">
                <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-multiselect [data]="documentModifiedByUser" textField="modifiedByUser"
                        valueField="modifiedByUser" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                        (valueChange)="modifiedByUserChange($event, filterService)">
                    </kendo-multiselect>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.modifiedByUser}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Modified Date" field="modifiedDate" filter="date" format="{0:dd MMM yyyy}">
                <ng-template kendoGridEditTemplate let-column="column" let-filter="filter"
                    let-filterService="filterService">
                    <kendo-textbox-container>
                        <kendo-datepicker [format]="'dd MMM yyyy'">
                        </kendo-datepicker>
                    </kendo-textbox-container>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.modifiedDate | date:'dd MMM yyyy'}}</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</fieldset>